import { isObject } from '../unknowns/isObject';
import { ensure } from './ensure';

export const ensureRequiredObject: <T>(obj: T) => asserts obj is Required<T> = obj => {
  ensure(obj);

  if (!isObject(obj)) {
    throw new Error('Value is not an object.');
  }

  for (const key in obj) {
    ensure(obj[key]);
  }
};
